// extracted by css-extract-rspack-plugin
var _1 = "DKIRvTLLPCY84La_";
export { _1 as "listLoader" }
// extracted by css-extract-rspack-plugin
var _1 = "DKIRvTLLPCY84La_";
export { _1 as "listLoader" }
